import { Fragment, useEffect } from "react";
import {
  FaCheck,
  FaChevronCircleLeft,
  FaChevronCircleRight,
} from "react-icons/fa";
import { useLocation, useHistory } from "react-router-dom";

const locations = [
  {
    location: "/where",
    position: 0,
  },
  {
    location: "/when",
    position: 1,
  },
  {
    location: "/what",
    position: 2,
  },
  {
    location: "/anything",
    position: 3,
  },
  {
    location: "/budget",
    position: 4,
  },
  {
    location: "/confirm",
    position: 5,
  },
];

const CreationFooter = ({
  height,
  useDoneBtn,
  onClickedNext,
  onClickedBack,
  disableNext,
  useConfirmBtn,
  hideNextBtn,
  hideBackBtn,
  relative,
}) => {
  let history = useHistory();
  const location = useLocation();

  const nextOrBack = (direction) => {
    const currentLocation = locations.find(
      (loc) => loc.location === location.pathname
    );
    let newLocation;
    if (direction === "next") {
      newLocation = locations.find(
        (loc) => loc.position === currentLocation.position + 1
      );
    } else if (direction === "back") {
      newLocation = locations.find(
        (loc) => loc.position === currentLocation.position - 1
      );
    }
    if (newLocation) {
      history.push(`${newLocation.location}`);
    }
  };

  return (
    <Fragment>
      <div
        className={`w-full ${
          relative ? "hidden" : "fixed"
        } bottom-0 left-0 z-10`}
      >
        <img
          src="/images/swirl-cut-bg.png"
          className="w-full h-[150px] md:mb-[-27%] md:static "
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // padding: "0 10%",
          // backgroundImage: "url(/images/swirl-cut-bg.png",
          // zIndex: 10,
        }}
        className={`px-1 md:px-[10%] z-10 h-[${height}px] w-full bottom-8 ${
          relative ? "relative" : "fixed"
        }`}
      >
        {!hideBackBtn && (
          <a
            className="cursor-pointer inline-flex items-center px-4 py-2 text-3xl text-gray-500 rounded-lg  dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white font-black relative z-10"
            onClick={() => {
              if (onClickedBack) {
                onClickedBack();
              } else {
                nextOrBack("back");
              }
            }}
          >
            <FaChevronCircleLeft
              style={{
                marginRight: "10px",
              }}
            />
            back
          </a>
        )}

        {!hideNextBtn && (
          <button
            className={`${
              disableNext ? "opacity-50" : ""
            } inline-flex items-center px-4 py-2 ml-3 text-3xl text-gray-500 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white mirum-color-orange font-black relative z-10`}
            onClick={() => {
              if (disableNext) {
                return;
              } else if (onClickedNext) {
                onClickedNext();
              } else {
                nextOrBack("next");
              }
            }}
          >
            {useDoneBtn ? "done" : null}
            {useConfirmBtn ? "confirm" : null}
            {!useDoneBtn && !useConfirmBtn ? "next" : null}
            <div
              style={{
                marginLeft: "10px",
              }}
            >
              {useDoneBtn ? <FaCheck /> : null}
              {useConfirmBtn ? <FaCheck /> : null}
              {!useDoneBtn && !useConfirmBtn ? <FaChevronCircleRight /> : null}
            </div>
          </button>
        )}
      </div>
    </Fragment>
  );
};

export default CreationFooter;
